import React from "react";
import * as Icons from "lucide-react";
import { UsersList } from "@/pages/user_rows";

// Bloc « Membres actifs » extrait de Users.js (limite le volume JSX par fichier
// pour éviter le débordement du plugin de dev visual-edits).
export function ActiveMembersSection({ users, currentUserId, t, onWhatsApp, onRegen, onEdit, onResetPin, onToggle }) {
  return (
    <div className="space-y-2">
      <h2 className="font-bold flex items-center gap-2">
        <Icons.Users className="h-4 w-4" /> {t("active_members")} ({users.length})
      </h2>
      <UsersList users={users} currentUserId={currentUserId} t={t} onWhatsApp={onWhatsApp}
        onRegen={onRegen} onEdit={onEdit} onResetPin={onResetPin} onToggle={onToggle} />
    </div>
  );
}
